export default { sha: '60d1d20d4a087bdc352128f1c79d40e6e376afe6', buildNumber: 'undefined' }
